import { render, staticRenderFns } from "./ImagingResults.vue?vue&type=template&id=a5f9d49e&"
import script from "./ImagingResults.vue?vue&type=script&lang=js&"
export * from "./ImagingResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports